<button class="z-5 pos-absolute top-1 left-50"
        (click)="closeModal()"
        [attr.aria-label]="'Close Modal' | translate">
    <i class="icon-close va-m"
       aria-hidden="true"></i>
</button>

@if (modalData?.sizeGuideId) {
<product-size-guide class="wrap"
                    [variant]="modalData.sizeGuideId" />
}
